import { graphql } from "../../graphql";

export const PageFragment = graphql(`
  fragment PageFragment on pages {
    id
    idx
    name
    type
    period_highlights
    updated_at
    user_id
    extra_header_height
    created_at
    column_highlights
    cell_highlights
    adhoc_spreads
    commodity_parent_group
    geographical_region
    commodity_group
    package
    description
    source
    field_name
		main_column_type
		main_column_width
  }
`);

export const PageMemberFragment = graphql(`
	fragment PageMemberFragment on page_member {
		page_id
		user_id
		page_order
		Page {
			...PageFragment
		}
	}
`);

export const PagesQuery = graphql(`
  query PagesQuery($userId: String!) {
    pages(where: { user_id: { _eq: $userId } }, order_by: { idx: asc }) {
      ...PageFragment
    }
  }
`);

export const PagesByPageIdsQuery = graphql(`
	query PagesByPageIdsQuery($ids: [String!]!) {
		pages(where: { id: { _in: $ids } }, order_by: { idx: asc }) {
			...PageFragment
		}
	}
`);

export const PageMembersByPageIdsQuery = graphql(`
	query PageMembersByPageIdsQuery($pageIds: [String!]!) {
		page_member(where: { page_id: { _in: $pageIds } }) {
			...PageMemberFragment
		}
	}
`);

export const PageMembersByUserIdQuery = graphql(`
	query PageMembersByUserIdQuery($userId: String!) {
		page_member(where: { user_id: { _eq: $userId } }) {
			...PageMemberFragment
		}
	}
`);

export const PagesSubscription = graphql(`
	subscription PagesSubscription($pageIds: [String!]!) {
		pages(where: { id: { _in: $pageIds } }, order_by: { idx: asc }) {
			...PageFragment
		}
	}
`);

export const PageMemberQuery = graphql(`
	query PageMemberQuery($pageIds: [String!]!, $userId: String!) {
		page_member(
			where: { 
				_or: [
					{ page_id: { _in: $pageIds } },
					{ user_id: { _eq: $userId } }
				]
			}
		) {
			...PageMemberFragment
		}
	}
`);

export const PageMemberSubscription = graphql(`
	subscription PageMemberSubscription($pageIds: [String!]!, $userId: String!) {
		page_member(
			where: { 
				_or: [
					{ page_id: { _in: $pageIds } },
					{ user_id: { _eq: $userId } }
				]
			}
		) {
			...PageMemberFragment
		}
	}
`);

export const PageUpdateMutation = graphql(`
  mutation Update_pages_by_pk($pageId: String!, $values: pages_set_input) {
    update_pages_by_pk(pk_columns: { id: $pageId }, _set: $values) {
      id
    }
  }
`);

export const PageMemberUpdateMutation = graphql(`
	mutation Update_page_member($userId: String!, $pageId: String!, $pageOrder: String!) {
		update_page_member(
			where: { user_id: { _eq: $userId }, page_id: { _eq: $pageId } }
			_set: { page_order: $pageOrder }
		) {
			affected_rows
		}
	}
`);

export const PageInsertMutation = graphql(`
  mutation PageInsert($page: pages_insert_input!) {
    insert_pages_one(object: $page) {
      name
      idx
    }
  }
`);

export const PageMemberInsertMutation = graphql(`
	mutation PageMemberInsert($member: page_member_insert_input!) {
		insert_page_member_one(object: $member) {
			page_id
			user_id
			page_order
		}
	}
`);

export const PageInsertMany = graphql(`
  mutation PageInsertMany($objects: [pages_insert_input!]!) {
    insert_pages(objects: $objects) {
      affected_rows
    }
  }
`);

export const PageMemberInsertMany = graphql(`
	mutation PageMemberInsertMany($objects: [page_member_insert_input!]!) {
		insert_page_member(objects: $objects) {
			affected_rows
		}
	}
`);

export const PageDeleteMutation = graphql(`
  mutation PageDelete($id: String!) {
    delete_pages_by_pk(id: $id) {
      id
    }
  }
`);

export const PageMemberDeleteMutation = graphql(`
	mutation PageMemberDelete($userId: String!, $pageId: String!) {
		delete_page_member(
			where: { user_id: { _eq: $userId }, page_id: { _eq: $pageId } }
		) {
			affected_rows
		}
	}
`);

export const PageMembersDeleteByUserMutation = graphql(`
	mutation PageMembersDeleteByUser($userId: String!) {
		delete_page_member(where: { user_id: { _eq: $userId } }) {
			affected_rows
		}
	}
`);

export const PageProductsFragment = graphql(`
  fragment PageProductsFragment on page_products {
    id
    grid_id
    idx
    decimal_places
    column_width
    column_type
    column_field_selector
    page_id
    product_id
    thousands_separator
    user_id
    updated_at
    deleted_at
  }
`);

export const AllPageProductsQuery = graphql(`
	query AllPageProductsQuery {
		page_products {
			...PageProductsFragment
		}
	}
`);

export const AllPageProductsSub = graphql(`
  subscription AllPageProductsSub($pageIds: [String!]!) {
		page_products(where: { page_id: { _in: $pageIds } }) {
      ...PageProductsFragment
    }
  }
`);

export const PageProductsQueryByIds = graphql(`
  query PageProductsQueryByIds($ids: [String!]!) {
    page_products(where: { page_id: { _in: $ids } }) {
      ...PageProductsFragment
    }
  }
`);

export const PageProductUpdateSub = graphql(`
	subscription PageProductUpdateSub($since: timestamptz!) {
		page_products(where: { updated_at: { _gte: $since } }) {
			...PageProductsFragment
		}
	}
`);

export const PageProductsSubscription = graphql(`
  subscription PageProductsSubscription($pageId: String!) {
    page_products(
      where: { page_id: { _eq: $pageId } }
      order_by: { idx: asc }
    ) {
      ...PageProductsFragment
    }
  }
`);

export const PageProductUpdateMany = graphql(`
  mutation PageProductUpdateMany($updates: [page_products_updates!]!) {
    update_page_products_many(updates: $updates) {
      returning {
        id
      }
    }
  }
`);

export const PageProductInsertMany = graphql(`
  mutation PageProductsInsert($objects: [page_products_insert_input!]!) {
    insert_page_products(objects: $objects) {
      affected_rows
    }
  }
`);

export const PageProductsHardDelete = graphql(`
  mutation PageProductsHardDelete($products: [String!]!) {
    delete_page_products(where: { id: { _in: $products } }) {
      affected_rows
    }
  }
`);
